import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('delete-rouge-user', {
  template: require('./template.html'),
  name: 'delete-rouge-user',
  mixins: [guid],
  computed: {
    ...mapGetters(['allUsers', 'stormSession', 'stormUser']),
    confirmed() {
      return this.user && this.user.email === this.confirmemail;
    },
  },
  components: {
    dropsLoader,
  },
  data() {
    return {
      loading: false,
      confirmemail: '',
      deleteError: false,
      unsubscribeEmail: true,
      emptyMsg: 'You must confirm user email.',
    };
  },
  props: ['modal', 'user'],
  methods: {
    async deleteRougueUser() {
      if (!this.confirmed) {
        this.deleteError = this.emptyMsg;
        return;
      }
      try {
        this.loading = true;
        this.deleteError = false;
        await this.$lightning([{
          name: 'removeRougeUser',
          payload: {
            unsubscribeEmail: this.unsubscribeEmail,
            user: this.user,
          },
        }]);
        this.$store.dispatch('removeStormUser', {
          sub: this.user.sub,
        });
        this.$store.dispatch('addNotification', {
          id: this.guid(),
          type: 'success',
          message: `Successfully removed user: ${this.user.email}`,
        });
        setTimeout(() => {
          this.closeModal();
          this.loading = false;
        }, 500);
      } catch (e) {
        const message = e.message || e;
        this.$log.error = message;
        this.deleteError = message;
        this.loading = false;
      }
    },
    checkInput() {
      if (!this.confirmed) {
        this.deleteError = this.emptyMsg;
      } else {
        this.deleteError = false;
      }
    },
    closeModal() {
      this.$emit('toggle-confirm', false);
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/drzzle-accounts/delete-rouge-user/index.js